import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectorRef } from "@angular/core";
import { delay, SharedService } from '../../shared'
import {
    IQuestionnaireSection, IQuestionnaireSubSection, IMedikamentObj, IMedikamentResObj, INichtMedikamentResObj,
    EnumSectionStatus, EnumMedikamentName, EnumQuestionType, EnumFreeTextType, GenereateMedikamentRes, GenereateNichtRes,
    freeTextInputs,
    LANGUAGE_ENUM
} from '../questionnaire.model';
import { cloneDeep } from "lodash";


@Component({
    selector: 'medikament',
    templateUrl: "./medikament.component.html",
    styleUrls: ["./medikament.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class MedikamentComponent implements OnInit {
    @Input() LANGUAGE: LANGUAGE_ENUM = LANGUAGE_ENUM.DE;
    @Input() section: IQuestionnaireSection = null;
    @Input() subSection: IQuestionnaireSubSection = null;
    @Input() medikamentObj: IMedikamentObj;
    @Input() status: EnumSectionStatus = EnumSectionStatus.ACTIVE;
    @Input() minMonth: string = "";
    @Input() maxMonth: string = "";
    @Input() showRemove: boolean = false;

    LANGUAGE_ENUM = LANGUAGE_ENUM;

    EnumMedikamentName = EnumMedikamentName;
    EnumQuestionType = EnumQuestionType;
    EnumFreeTextType = EnumFreeTextType;

    EnumSectionStatus = EnumSectionStatus;


    constructor(private cd: ChangeDetectorRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
    }

    getTextAreaColSpan() {
        switch (this.medikamentObj.medikamentName) {
            case EnumMedikamentName.MedikamentTherapie:
                return 5;
            default:
                return 4;
        }
    }

    fnToggleFreeText(medikament: IMedikamentResObj | INichtMedikamentResObj) {
        medikament.showFreeText = !medikament.showFreeText;
    }

    fnRemoveOption(index) {
        if (this.status == EnumSectionStatus.COMPLETED) {
            return;
        }
        let responseData: any[] = cloneDeep(this.medikamentObj.responseData);
        responseData.splice(index, 1);
        this.medikamentObj.responseData = responseData;
    }

    fnAddExtraOption() {
        if (this.status == EnumSectionStatus.COMPLETED) {
            return;
        }
        let responseData: any[] = this.medikamentObj.responseData;
        switch (this.medikamentObj.medikamentName) {
            case EnumMedikamentName.MedikamentTherapie:
                responseData.push(GenereateMedikamentRes());
                this.medikamentObj.responseData = responseData;
                break;
            case EnumMedikamentName.NichtTherapie:
                responseData.push(GenereateNichtRes());
                this.medikamentObj.responseData = responseData;
                break;
        }
    }

    changeFunction(itemObj: IMedikamentObj, response: IMedikamentResObj | INichtMedikamentResObj, itemKey: string) {
        response.hasError[itemKey] = false;
        if (!this.isMedikamentFreeTextShow(itemObj, response, itemKey)) {
            response[itemKey].freeText = null;
        }
    }

    isMedikamentFreeTextShow(itemObj: IMedikamentObj, response: IMedikamentResObj | INichtMedikamentResObj, itemKey: string) {
        if (itemObj[itemKey].inputType == EnumQuestionType.DROPDOWN) {
            let value = response[itemKey]?.value;
            if (value) {
                if (itemObj[itemKey].multiple) {
                    var matched = freeTextInputs.filter(e => value.indexOf(e) !== -1);
                    return matched.length > 0;
                } else {
                    return freeTextInputs.indexOf(value) > -1;
                }
            }
        }
        return false;
    }
}
